// The chrome connection button (NavConnectionIcon.vue): while online and the files kept for offline use are still
// downloading (legacyNav.filesSyncing), the wifi icon fills up one wave after another - 1, 2, 3, 1, 2, 3...
export const CONNECTION_SYNC_FRAMES = Object.freeze(['wifi_1_bar', 'wifi_2_bar', 'wifi']);
export const CONNECTION_SYNC_FRAME_MS = 500;

/**
 * @param {boolean} online
 * @param {number|null} frame  index in CONNECTION_SYNC_FRAMES while animating, null otherwise
 * @returns {string} the Material Symbols ligature
 */
export function connectionIcon(online, frame = null) {
	if (!online) return 'wifi_off';
	return CONNECTION_SYNC_FRAMES[frame] ?? 'wifi';
}
